export default __webpack_public_path__ + "static/matcap6-66bbfddda8b6685a923d5aed503ed8bb.jpeg";